import React from 'react';
import { Grid, Stack } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';
import ComparablesExpenses from './ComparablesExpenses';
import { comparableExpenseFormFields } from './comparableExpenseFormConfig';

const formConfig: FormOptions = {
  fields: comparableExpenseFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type OperatingExpensesProps = {
  form: Form;
};

const ComparableExpensesContainer = observer(({ form }: OperatingExpensesProps) => {
  return (
    <Grid container>
      <Stack spacing={2}>
        <ComparablesExpenses form={form} />
      </Stack>
    </Grid>
  );
});

export default wrapForm({
  ...formConfig,
})(ComparableExpensesContainer);
